<template>
  <div class="d-flex" :class="editingModeClass">
    <div v-if="!editingMode">
      {{ tkey(params.value) }}
    </div>
    <v-tooltip v-if="editingMode && isDisabled" :text="params.disabledTooltip" location="top">
      <template #activator="{ props: tooltipProps }">
        <div v-bind="tooltipProps" style="width: 80%">
          <v-select
            v-model="fieldValue"
            white
            width="100%"
            :items="items"
            :placeholder="$t('general.select')"
            :menu-props="{ 'z-index': 200 }"
            :disabled="true"
            hide-details
          />
        </div>
      </template>
    </v-tooltip>
    <v-select
      v-if="editingMode && !isDisabled"
      v-model="fieldValue"
      white
      width="80%"
      :items="items"
      :placeholder="$t('general.select')"
      :menu-props="{ 'z-index': 200 }"
      hide-details
      @update:model-value="setFieldValue"
    />
  </div>
</template>

<script>
import { useInternationalization } from '@/composables/use-internationalization';
import { useAssortmentCanvasStore } from '@/stores/assortment-canvas';
import { isEqual } from 'lodash';
import { mapActions, mapState } from 'pinia';

export default {
  setup() {
    const { tkey } = useInternationalization('assortmentCanvasPage.spacebreakSettings.constraints');
    return { tkey };
  },
  data() {
    return {
      fieldValue: null,
      items: null,
    };
  },
  computed: {
    ...mapState(useAssortmentCanvasStore, ['constraintEditing']),
    editingMode() {
      return (
        this.constraintEditing.constraint.open &&
        isEqual(this.params.node.id, this.constraintEditing.constraint.rowNodeId)
      );
    },
    isSelected() {
      return this.params.node.isSelected();
    },
    isDisabled() {
      return this.params.isDisabledCheck
        ? this.params.isDisabledCheck(this.constraintEditing)
        : false;
    },
    editingModeClass() {
      return this.editingMode && this.isSelected ? 'editing-padding-top' : '';
    },
  },
  watch: {
    editingMode() {
      this.fieldValue = this.params.value;
    },
  },
  created() {
    this.items = this.params.selectItems;
    this.fieldValue = this.params.value;
  },
  methods: {
    ...mapActions(useAssortmentCanvasStore, [
      'setConstraintRowNodeData',
      'updateConstraintRowNodeData',
    ]),
    setFieldValue(value) {
      this.updateConstraintRowNodeData({ data: value, field: this.params.field });
      this.fieldValue = value;
      if (this.params.sideEffects) {
        this.params.sideEffects(value, this.updateConstraintRowNodeData);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn {
  padding-bottom: 0 !important;
}
</style>
